var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66675 5.33301L4.34174 18.8328C4.43044 20.6068 5.89466 21.9997 7.67091 21.9997H16.3293C18.1055 21.9997 19.5697 20.6068 19.6584 18.8328L20.3334 5.33301H3.66675ZM5.41883 6.99967L6.00632 18.7496C6.05068 19.6366 6.78279 20.333 7.67091 20.333H16.3293C17.2174 20.333 17.9495 19.6366 17.9938 18.7496L18.5813 6.99967H5.41883Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4999 5.33333H9.49992V4.5C9.49992 4.03976 9.87301 3.66667 10.3333 3.66667H13.6666C14.1268 3.66667 14.4999 4.03976 14.4999 4.5V5.33333ZM7.83325 7V4.5C7.83325 3.11929 8.95254 2 10.3333 2H13.6666C15.0473 2 16.1666 3.11929 16.1666 4.5V7H7.83325Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.16634C2 5.7061 2.3731 5.33301 2.83333 5.33301H21.1667C21.6269 5.33301 22 5.7061 22 6.16634C22 6.62658 21.6269 6.99967 21.1667 6.99967H2.83333C2.3731 6.99967 2 6.62658 2 6.16634Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5001 10.333C14.9603 10.333 15.3334 10.7061 15.3334 11.1663V15.333C15.3334 15.7932 14.9603 16.1663 14.5001 16.1663C14.0398 16.1663 13.6667 15.7932 13.6667 15.333V11.1663C13.6667 10.7061 14.0398 10.333 14.5001 10.333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50008 10.333C9.96032 10.333 10.3334 10.7061 10.3334 11.1663V15.333C10.3334 15.7932 9.96032 16.1663 9.50008 16.1663C9.03984 16.1663 8.66675 15.7932 8.66675 15.333V11.1663C8.66675 10.7061 9.03984 10.333 9.50008 10.333Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7cafe5791ba61e985f4a970cce4e2fe9.svg";
export { ForwardRef as ReactComponent };